import { Injectable, Signal } from '@angular/core';

/**
 * Abstract bearer-token source for {@link CustomerChatClient}.
 *
 * Mirrors `@customer-portal/api`'s `ApiTokenProvider`: keeping it abstract lets this
 * `type:data-access` lib stay within Nx module boundaries (it must not depend on CIAM). The app
 * aliases it to `AuthenticationStore` via `{ provide: CustomerChatTokenProvider, useExisting: AuthenticationStore }`.
 */
@Injectable()
export abstract class CustomerChatTokenProvider {
  /** The raw access token string (empty when not authenticated). */
  public abstract readonly token: Signal<string>;
}
